
const baseUrl = process.env.VUE_APP_BASE_URL || '';

// 路径常量
const PATHS = {
  YELLOW_COLLECTION: '/brand/yellow-collection',
};

const brandLink = `${baseUrl}${PATHS.YELLOW_COLLECTION}`;

const PrimaryMenu = [
  { title: "商城", code: 'shopping', link: "/" },
  { title: "品牌", code: 'brand', link: brandLink },
]

export default {
  PrimaryMenu
}